import { FormikProps, useFormik } from 'formik';
import { getAddSubscriptionRestrictionFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { useGetRoles } from '../../../../services/redux/api/rolesApi';
import { FormikValues } from 'formik/dist/types';
import { usePostPutSubscriptionRestriction } from '../../../../services/redux/api/subscriptionsApi';
import {
  RestrictionScope,
  SubscriptionType,
} from '../../../../shared/constants';
import { ISubscriptionRestriction } from '../../../../types/interfaces/subscription-restriction';

export function useAddSubscriptionRestrictionComponent(
  onClose: () => void,
  restriction?: ISubscriptionRestriction,
) {
  const { t } = useTranslation();
  const { data: roles } = useGetRoles();
  const [postPutSubscriptionRestriction, { isLoading }] =
    usePostPutSubscriptionRestriction();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddSubscriptionRestrictionFormValidation(t),
    initialValues: {
      type: restriction?.type || SubscriptionType.starter,
      restrictionScope:
        restriction?.restrictionScope || RestrictionScope.programItem,
      maxValue: restriction?.maxValue || 0,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutSubscriptionRestriction({
      id: restriction?.id,
      body: {
        type: values.type,
        restrictionScope: values.restrictionScope,
        maxValue: values.maxValue,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return { formik, roles, isLoading };
}
